import { KeyRound } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useUploadManager } from "@/hooks/useUploadManager";

/**
 * App-wide notice while uploads are on hold because the sign-in expired mid-run. Nothing
 * has failed: files already under way keep uploading, the rest wait. "Sign in again"
 * opens the login in a new tab (so this tab — and its in-memory queue — is never
 * reloaded); the moment that sign-in lands, the uploads carry on here by themselves.
 */
const SessionExpiredBanner = () => {
  const { sessionExpired, signInAgain } = useUploadManager();
  if (!sessionExpired) return null;
  return (
    <div
      role="alert"
      className="fixed inset-x-0 top-0 z-[60] flex items-center justify-center gap-3 border-b border-amber-500/40 bg-amber-50 px-4 py-2 text-sm text-foreground shadow-sm dark:bg-amber-950"
      style={{ paddingTop: "calc(env(safe-area-inset-top, 0px) + 0.5rem)" }}
    >
      <KeyRound className="h-4 w-4 shrink-0 text-amber-600 dark:text-amber-400" />
      <span className="min-w-0">
        Your sign-in has expired, so uploads are paused. Sign in again and they’ll carry on from where they
        stopped — nothing has been lost.
      </span>
      <Button size="sm" className="h-7 shrink-0" onClick={signInAgain}>
        Sign in again
      </Button>
    </div>
  );
};

export default SessionExpiredBanner;
